import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class EmployeeSearchModel extends SearchModel<any> {

    static STATUS_UNEMPLOYED: string = "Unemployed";

    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "employeeId";
    }

    override isDiscontinued(data: any): boolean {
        return data.status === EmployeeSearchModel.STATUS_UNEMPLOYED;
    }
}
